



















import { Component, Vue } from "vue-property-decorator";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useInterestRateStore } from "@/employer/store/interestRate";
import { EmployerFeeScheduleTableItem, useEmployerFeeScheduleStore } from "@/employer/store/employerFeeSchedule";
import { InterestRateTableItem } from "@/shared/types";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class HsaBankFeeScheduleAndInterestRatesInfo extends Vue {
  interestRateStore = useInterestRateStore();
  employerFeeScheduleStore = useEmployerFeeScheduleStore();

  mounted (): void {
    if (this.interestRateStore.isUninitialized) {
      this.interestRateStore.loadInterestRates();
    }
    if (this.employerFeeScheduleStore.isUninitialized) {
      this.employerFeeScheduleStore.loadEmployerFeeSchedulesActiveForUser();
    }
  }

  get isLoading (): boolean {
    return this.interestRateStore.isLoading
        || this.employerFeeScheduleStore.isLoading;
  }

  get interestRates (): InterestRateTableItem[] {
    if (!this.interestRateStore.interestRates ||
      !this.interestRateStore.interestRates.length) {
      return [];
    }
    return this.interestRateStore.getInterestRatesAsTableData;
  }

  get feeSchedules (): EmployerFeeScheduleTableItem[] {
    if (!this.employerFeeScheduleStore.employerFeeSchedules ||
        !this.employerFeeScheduleStore.employerFeeSchedules.length) {
      return [];
    }
    return this.employerFeeScheduleStore.getEmployerFeeSchedulesAsTableItems;

  }
}
